import React, { useState, useEffect } from "react"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import Block from "@bappweb/block"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const SssList = (props) => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [faqText, setFaqText] = useState<any[]>([]);

  useEffect(() => {
    if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Faq"))) {
      setFaqText(JSON.parse(getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Faq")))
    }
  }, [sessionData])

  return (
    <Page padding={false}>
      <Panel hasFooter={false} noHeader id={props.id} className="ssslist">
        <Element type="h2">Bilmem gereken başka neler var?</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          className=""
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item: any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              ><Block dangerouslySetInnerHTML={{ __html: item?.data }} /></List.Item>
            )
          })}

        </List>
      </Panel>
    </Page>
  )
}

export default SssList
